import * as React from 'react';
import { SVGProps } from 'react';

const IconRevertSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.853 2.36 2.5.5 1 6h5.5L5.03 3.978a5 5 0 1 1-1.598 6.056l-1.827.813a7 7 0 1 0 2.248-8.486z" />
  </svg>
);
export default IconRevertSizeS;
